// @mui material components
import Card from "@mui/material/Card";

// Matoerial Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import SearchInputControled from "components/CRPComponents/Forms/components/SearchInputControled";
import DataTableControled from "examples/Tables/DataTableControled";
import { ApiCMSWithSetData } from "data/ApiCMS";
import { useEffect, useMemo } from "react";
import FilterMenu from "../GenericTable/FilterMenu";
import { DowloadCSV } from "components/CRPComponents/DowloadCSV";
import useCurseDataTable from "./useCursesDataTable";
import CurseWithFilterTableProps from "./types";

import useFilters from "./Hook/useFilters";
import FilterCursesForTable from "./FilterCursesForTable";
function CurseWithFilterTable<T>(props: CurseWithFilterTableProps<T>): JSX.Element {
  const {
    handleChangePage,
    handleChangeFilter,
    error,
    loading,
    data,
    handleSearch,
    setSearchValue,
    searchValue,
    variables,
    handleChangeFilterCurses,
  } = useCurseDataTable({
    ...props,
    ApiSetData: props.ApiSetData ?? ApiCMSWithSetData,
  });

  const { filters, loadFilters, stateFilters, handleCheckbox } = useFilters();

  useEffect(() => {
    loadFilters();
  }, []);

  useEffect(() => {
    handleChangeFilterCurses();
  }, [window.location.search]);

  useMemo(() => {
    if (props?.hnadleResponse) props?.hnadleResponse(data as T);
  }, [data]);

  if ((data && error) || error) {
    return <p>Error : {error.message}</p>;
  }

  if (!data) return null;

  return (
    <MDBox my={3}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
        className="head"
      >
        {!props.title ? (
          props?.buttonCreate ?? <div />
        ) : (
          <MDButton
            variant="gradient"
            color="info"
            href={`${props.path}/${props?.createAddPath ?? "new"}`}
          >
            {props.title}
          </MDButton>
        )}
        {props.dowloadSvgJson ? (
          <>
            <DowloadCSV allFildsSvgh={props.allFildsSvgh} dowloadSvgJson={props.dowloadSvgJson} />
          </>
        ) : null}
        {props.filter ? (
          <FilterCursesForTable
            filters={filters}
            stateFilters={stateFilters}
            handleCheckbox={handleCheckbox}
          />
        ) : null}
        <MDBox display="flex" gap={3} alignItems="baseline">
          {props?.hiddenSearch ? null : (
            <SearchInputControled
              onSubmitSearch={handleSearch}
              value={searchValue}
              onChangeValue={setSearchValue}
              disabled={loading}
            />
          )}
          {props.useDefaultFilter !== false && (
            <FilterMenu
              useStatusString={props?.useStatusString}
              variables={variables}
              onChange={handleChangeFilter}
              buttonProps={{ loading, disabled: loading }}
            />
          )}
          {props.childrenFilters}
        </MDBox>
      </MDBox>
      <Card>
        <DataTableControled
          table={{
            columns: props.columnsTable.map((item) =>
              props?.action?.acessor === item.accessor ? props?.action?.column : item
            ),
            rows: props.formatRows(data as T),
          }}
          pagination={props.formatPagination(data as T)}
          onChangePage={handleChangePage}
          loading={loading}
        />
      </Card>
    </MDBox>
  );
}

export default CurseWithFilterTable;
